module.exports = __webpack_public_path__ + "img/laravel-logo.f5b5d6f6.png";